var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "products__categories-item",
      class: [
        _vm.modifier && "products__categories-item--" + _vm.modifier,
        {
          "products__categories-item--active": _vm.active
        }
      ]
    },
    [
      _c(
        "a",
        {
          staticClass: "products__categories-item-link",
          class: [
            _vm.modifier && "products__categories-item-link--" + _vm.modifier,
            {
              "products__categories-item-link--active": _vm.active
            }
          ],
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.$emit("click")
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "products__categories-item-inner" },
            [
              _vm.category.svgIconKey &&
              _vm.iconComponent(_vm.category.svgIconKey)
                ? _c(_vm.iconComponent(_vm.category.svgIconKey), {
                    tag: "component",
                    staticClass: "products__categories-item-icon",
                    class: [
                      _vm.modifier &&
                        "products__categories-item-icon--" + _vm.modifier
                    ]
                  })
                : _vm.category.image
                ? _c("img", {
                    staticClass: "products__categories-item-icon",
                    class: [
                      _vm.modifier &&
                        "products__categories-item-icon--" + _vm.modifier
                    ],
                    attrs: { src: _vm.category.image }
                  })
                : _c("SVGInfo", {
                    staticClass: "products__categories-item-icon",
                    class: [
                      _vm.modifier &&
                        "products__categories-item-icon--" + _vm.modifier
                    ]
                  }),
              _vm._v(" "),
              _c("span", {
                staticClass: "products__categories-item-text",
                class: [
                  _vm.modifier &&
                    "products__categories-item-text--" + _vm.modifier
                ],
                domProps: { innerHTML: _vm._s(_vm.category.name) }
              })
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }